import Color from '../Color.mjs'
import superMeta from '../_COMPONENT/metaComponentNode.mjs'

export default {
    ...superMeta,
    themeColor: Color.LIGHT_YELLOW,
    codeProp: 'termUserCode',
    mapProp: 'termMap',
    name: '业务术语',
    ownerIdProp: 'bdId',
    ownerTextProp: 'bdName',
    ownerType: 'BD',
    textProp: 'termTitle',
    type: 'BDTERM',
}
